export const DashboardSkeleton = () => (
  <div className="admin-dashboard-page admin-dashboard-page--minimal admin-skeleton" aria-hidden="true">
    <div className="admin-heading admin-dashboard-heading">
      <div className="skeleton-stack">
        <span className="skeleton short" />
        <span className="skeleton title" />
        <span className="skeleton text" />
      </div>
    </div>

    <section className="admin-dashboard-overview">
      <span className="skeleton title" />
      <div className="admin-dashboard-stats admin-dashboard-stats--wide">
        {Array.from({ length: 6 }).map((_, index) => (
          <div className="admin-dashboard-stat admin-dashboard-stat--skeleton" key={index}>
            <span className="skeleton admin-dashboard-stat-icon-skeleton" />
            <div className="skeleton-stack">
              <span className="skeleton short" />
              <span className="skeleton title" />
              <span className="skeleton text" />
            </div>
          </div>
        ))}
      </div>
    </section>

    <section className="admin-dashboard-priority">
      <div className="admin-dashboard-actions-row">
        <span className="skeleton admin-dashboard-action-skeleton" />
        <span className="skeleton admin-dashboard-action-skeleton" />
      </div>
    </section>
  </div>
);
